module.exports = __webpack_public_path__ + "img/logo-intratone-clipped.832fc4aa.svg";